// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__179TW","inputDescription":"styles_inputDescription__3Kmt-"};